import React from 'react'

export default function ReabarDetailing() {
  return (
    <div>ReabarDetailing</div>
  )
}
